import { useEffect } from 'react'

import { useEditor } from '../../hooks/useEditor'

import { ModePluginProps } from './interface'

export const ModePlugin = ({ disabled }: ModePluginProps) => {
  const editor = useEditor()

  useEffect(() => {
    editor.setEditable(!disabled)
  }, [editor, disabled])

  return null
}
